import { useState } from "react";
import { ViewportProps } from "react-map-gl";
import { ICoordinate } from "shared/types";
import { DEFAULT_COORDINATES, DEFAULT_ZOOM } from "./constants";

interface Props {
  coordinates?: ICoordinate | null;
  zoom?: number | null;
}

export const useViewport = ({ coordinates, zoom }: Props) => {
  const { longitude, latitude } = coordinates || {};

  const [viewport, setViewport] = useState<Partial<ViewportProps>>({
    longitude: longitude || DEFAULT_COORDINATES.longitude,
    latitude: latitude || DEFAULT_COORDINATES.latitude,
    zoom: zoom || DEFAULT_ZOOM,
  });

  return { viewport, setViewport };
};
